import { Container, Stack } from '@mantine/core';
import PageTitle from 'components/PageTitle';
import TableModuleManagementJobFamily from 'modules/pages/dacum/moduleManagementJobFamily/TableModuleManagementJobFamily';
import React from 'react';

const ModuleManagementJobFamilyPage = () => {
  return (
    <Container fluid>
      <Stack>
        <PageTitle
          title='Competency Module Management Job Family'
          description='Manage competency modules for job family your organization'
        />
        <TableModuleManagementJobFamily />
      </Stack>
    </Container>
  );
};

export default ModuleManagementJobFamilyPage;
